import React, { useState, useRef  } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactSVG from "react-svg";
import { Grid } from "@material-ui/core";
import { AccountMain, AccountPersonal} from "~/components/blocks";
import { Title, Margin, Text, Loading } from "~/components/elements";
import * as S from "./styles";
import ExitSVG from "~/assets/img/icon/sair.svg";
import Person from "~/assets/img/icon/person.svg";
import IconRight from "~/assets/img/icon/iconRight.svg";
import IconRightWhite from "~/assets/img/icon/iconRightWhite.svg";
import EditarIcon from "~/assets/img/icon/editar.svg";
import { useLocation, Link } from "react-router-dom";
import { FormUpdatePassword } from "~/components/blocks";
import { Creators as AccountActions } from "~/store/modules/account/actions";


import { Creators as AuthenticationActions } from "~/store/modules/authentication/actions";
import isMobile from "~/hooks/isMobile";
import history from "~/routes/history";

export default function AccountContent() {
  const containerRef = useRef(null);
  const location = useLocation();
  const [selected, setSelected] = useState(0);
  const [showMenu, setShowMenu] = useState(false);
  const [editPersonalData, setEdit] = useState(false);
  const [editSenha, setEditSenha] = useState(false);

  const loading = useSelector((state) => state.account.details.loading);

  const menuClick = (selection) => {
    setSelected(selection);
    setEdit(0);
  };

  const personalData = useSelector(
    (state) => state.account.details.dadosPessoais
  );
  const contactData = useSelector(
    (state) => state.account.details.dadosContato
  );
  const completedSignUp = useSelector(
    (state) => state.authentication.auth.user.cadastroCompleto
  );

  const MAX_CUPONS = 8;

  const [expanded, setExpanded] = useState(false);

  const mobile = isMobile();
  const dispatch = useDispatch();

  const toggleExpand = () => {
    setExpanded((prev) => {
      if (prev) {
        // containerRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
      }
      return !prev;
    });
  };

  return (
    <>
      <S.ContentHolder container justifyContent="space-between" maxWidth="sm">
        <S.NavbarHolder>
          <Margin mb={4}>
            <S.NameHolder>
              {personalData?.Nome ? (
                <Title as="5" level="6" levelDesktop="6">
                  <ReactSVG wrapper="svg" src={Person} />
                  Olá, {personalData?.Nome.split(" ")[0]}
                </Title>
              ) : null}
            </S.NameHolder>

            <S.AccountMenu>
              <S.MenuItem
                selected={selected === 0}
                onClick={() => {
                  menuClick(0);
                  setShowMenu(!showMenu);
                  setEditSenha(false)
                }}
                id="chalengeButton"
              >
                <Grid
                  container
                  justifyContent="space-between"
                  alignContent="center"
                >
                  <Text level="1">Minha conta</Text>
                  <ReactSVG src={selected === 0 ? IconRightWhite : IconRight} />
                </Grid>
              </S.MenuItem>
              <S.MenuItem
                selected={selected === 1}
                onClick={() => {menuClick(1); setEditSenha(false)}}
                className={showMenu ? "show" : "hide"}
                id="accountPersonalButton"
              >
                <Grid
                  container
                  justifyContent="space-between"
                  alignContent="center"
                >
                  <Text level="1">Meus dados</Text>
                  <ReactSVG src={selected === 1 ? IconRightWhite : IconRight} />
                </Grid>
              </S.MenuItem>
              <S.MenuItem
                className={showMenu ? "show" : "hide"}
                onClick={() => {
                  dispatch(AuthenticationActions.purgeAuthentication());
                  dispatch(AccountActions.resetUserDetails())
                  history.push({ pathname: "/", search: location.search });
                }}
                id="accountLogoutButton"
              >
                <Grid
                  container
                  justifyContent="space-between"
                  alignContent="center"
                >
                  <Text level="1">Sair</Text>
                  <ReactSVG src={ExitSVG} />
                </Grid>
              </S.MenuItem>
            </S.AccountMenu>
          </Margin>
        </S.NavbarHolder>
        <S.CardsHolder>
          {loading ? (
            <Margin>
              <Loading />
            </Margin>
          ) : selected === 0 ? (
            <>

              <Margin mb={2}>
                <Title as="2" levelDesktop="4" level="5">
                  <strong>Bebê Johnson's</strong>
                </Title>
              </Margin>

              <Margin mb={2}>
                <div>
                  Acompanhe aqui os cupons que você cadastrou na promoção Bebê Johnson's e o andamento do concurso Seu bebê pode ser a nossa nova estrela.
                </div>
              </Margin>
              <Margin mb={1}>

              <S.CoupomTitle>
                <h1>
                Você tem {personalData?.cupons?.length || 0} {personalData?.cupons?.length === 1 ? 'cupom' : 'cupons'} cadastrado{personalData?.cupons?.length === 1 ? '' : 's'}
                </h1>
              </S.CoupomTitle>
              </Margin>

              <div 
                ref={containerRef}
                style={{ maxHeight: expanded ? '400px' : '300px', overflowY: expanded ? 'scroll' : 'hidden'  }}>
                  <S.CuponsTable >
                      <thead>
                        <tr>
                          <th>Número do cupom fiscal</th>
                        </tr>
                      </thead>
                      
                      <tbody>
                        {personalData?.cupons?.map((cupom, index) => (
                          <tr key={index}>
                            <td>
                              {cupom.Numero}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                  </S.CuponsTable>
              </div>

              {(personalData?.cupons?.length < 20 || !personalData?.cupons) && (
                <S.ContainerBtnVerMais>
                  <Link to={"/cadastro-promo"}>
                    CADASTRAR PRODUTO
                  </Link>
                </S.ContainerBtnVerMais>
              )}

              {personalData?.cupons?.length > MAX_CUPONS && (
                <S.ContainerBtnVerMais>
                  <S.BtnVerMais variant="outlined" onClick={toggleExpand}>
                    <Text as="span" level="2">
                    {expanded ? 'ver menos' : 'ver todos os cupons'}</Text>
                  </S.BtnVerMais>
                </S.ContainerBtnVerMais>
              )}
              
              {personalData?.cupons?.length >= 20 && (
                  <S.BlueContainer>
                    <p>
                      Obrigado por <span className="yellow-text">participar </span>
                      da promoção!
                    </p>
                  </S.BlueContainer>
              )}

            </>
          ) : (
            <>
            {
              editPersonalData ? (
                <>
                <Margin mb={3}>
                <S.EditarDadosContainer>
                  <Title level="7" className="title">Editar Meus dados</Title>
                  <Title level="6" className="title">Informações para editar sua conta</Title>
                </S.EditarDadosContainer>
              </Margin>
                <AccountPersonal
                  mobile={mobile}
                  personalData={personalData}
                  setEdit={setEdit}
                  menuClick={menuClick}
                  edit={editPersonalData}
                  contactData={contactData}
                />

              </>
 
              ) : 
              
                editSenha
                ?
                <>
                <Margin mb={2}>
                  
                  <S.Title level="7">Editar Senha</S.Title>
                </Margin>

                <Margin mb={2}>
                  <p>
                  Digite a nova senha nos campos abaixo
                  </p>                
                </Margin>

                <FormUpdatePassword setEditSenha={setEditSenha}></FormUpdatePassword>

                </>
                
                :

                (
                
                  <>
                    <Margin mb={3}>
                      <S.DadosContainer onClick={() => setEdit(true)}>
                        <Title level="6" className="title">Meus dados</Title>
                        <S.EditBtnContainer>
                          <ReactSVG wrapper="span" src={EditarIcon} />
                          <p>Editar</p>
                        </S.EditBtnContainer>
                      </S.DadosContainer>
                    </Margin>
                    <AccountMain
                      mobile={mobile}
                      personalData={personalData}
                      contactData={contactData}
                      editClick={() => setEdit(true)}
                      history={history}
                      completedSignUp={completedSignUp}
                      setEditSenha={setEditSenha}
                    />
                    
                  </>
                )
              

            }
          </>
          )}
        </S.CardsHolder>
      </S.ContentHolder>
    </>
  );
}
